import { FC } from 'react'
import {
	Alert,
	Button,
	Container,
	Header,
	SpaceBetween
} from '@cloudscape-design/components'
import type { MongoDBRequest } from '../../../types/mongodb'
import useAcceptMongoDB from '../../../hooks/mutate/useAcceptMongoDB'
import { getMongoDBErrorMessage } from '../RequestError'

interface ApprovalFormProps {
	request: MongoDBRequest
	onClose: () => void
	onSubmitted: () => void
}

const ApprovalForm: FC<ApprovalFormProps> = ({
	request,
	onClose,
	onSubmitted
}) => {
	const {
		mutate: acceptMongoDB,
		isLoading,
		isError,
		error
	} = useAcceptMongoDB(request.mongoDBID)
	const eligible =
		request.status === 'PENDING_APPROVAL' && !request.correctionPending

	const handleApprove = () => {
		if (!eligible || isLoading) return
		acceptMongoDB(
			{
				action: 'APPROVE',
				mongoDBID: request.mongoDBID,
				expectedLastUpdatedTime: request.lastUpdatedTime
			},
			{ onSuccess: onSubmitted }
		)
	}

	return (
		<Container header={<Header variant="h2">Approve MongoDB Request</Header>}>
			<SpaceBetween direction="vertical" size="m">
				<Alert type="info">
					Confirm that you have reviewed the Application and all cluster
					settings before approving this request.
				</Alert>
				{isError && <Alert type="error">{getMongoDBErrorMessage(error)}</Alert>}
				<SpaceBetween direction="horizontal" size="xs">
					<Button disabled={isLoading} onClick={onClose}>
						Cancel
					</Button>
					<Button
						variant="primary"
						loading={isLoading}
						disabled={!eligible || isLoading}
						onClick={handleApprove}
					>
						Approve
					</Button>
				</SpaceBetween>
			</SpaceBetween>
		</Container>
	)
}

export default ApprovalForm
